// src/theme/colors.ts

export const brand = {
  pink: '#ff2f92',
  pinkHover: '#ff4fa3',
  // Deeper pink for text on light surfaces (brand pink is ~3.3:1 on white)
  pinkInk: '#d0196f',

  purple: '#8b5cf6',
  blue: '#38bdf8',

  white: '#ffffff',
};

export const ink = {
  primary: '#1c1a33',
  secondary: '#625d80',
  icon: '#4b4670',
};

export const surfaces = {
  darkPaper: 'rgba(20, 24, 40, 0.55)',
  // Frosted glass on desktop; more opaque on phones where blur is skipped
  lightPaper: 'rgba(255, 255, 255, 0.55)',
  lightPaperSolid: 'rgba(255, 255, 255, 0.82)',
  // The dark mode header ground, also used for the header in light mode
  darkBar: '#0b0d1c',
  lightGround: '#f4f2fb',

  darkDialog: 'rgba(14, 16, 30, 0.95)',
  lightDialog: '#ffffff',
};

export const dividers = {
  dark: 'rgba(255, 255, 255, 0.1)',
  light: 'rgba(80, 60, 140, 0.14)',
};

export const states = {
  disabledTextDark: 'rgba(255,255,255,0.4)',
  disabledBorderDark: 'rgba(255,255,255,0.25)',
  disabledTextLight: 'rgba(28,26,51,0.38)',
  disabledBorderLight: 'rgba(28,26,51,0.2)',
};

export const gradients = {
  primary: `linear-gradient(
    90deg,
    ${brand.pink} 0%,
    ${brand.purple} 50%,
    ${brand.blue} 100%
  )`,
};
